"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientApplicationInsightsConfig = void 0;
/**
 * Lets you retrieve configuration for application insights on the client.
 *
 * @example
 * ```js
 * // appRender.ts
 * import { Logger, ApplicationInsights, getClientApplicationInsightsConfig } from '@ori/logger';
 * export const render = (rootEl) => {
 *  ApplicationInsights.initialize(getClientApplicationInsightsConfig())
 *
 *  Logger.configure({
 *    metadata: {
 *      myMeta: '🎉'
 *    },
 *    ...
 *  });
 * };
 * ```
 */
const getClientApplicationInsightsConfig = () => typeof window === 'undefined' ? undefined : window.oriAppInsightsSettings;
exports.getClientApplicationInsightsConfig = getClientApplicationInsightsConfig;
